import { adminLogin } from "@/services/connectBFF";

const actions = {
  async loginAdmin({ commit }, admin) {
    const params = {
      username: admin.username,
      password: admin.password,
    };

    const response = await adminLogin.get("", { params: { ...params } });

    commit("setAdmin", response.data.success);
  },

  setAdmin({ commit }, aprove) {
    commit("setAdmin", aprove);
  },
};

export default actions;
